import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import Select from 'react-select';
import _ from 'lodash';

import { renderPreview } from '../../models/NumberRange';

import classes from './NumberRangePicker.scss';

const mapActionCreators = {};

const mapStateToProps = state => ({
  numberRanges: state.numberRange.numberRanges,
});

class NumberRangePicker extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.default,
    };
  }

  componentWillMount() {}

  setValue = value => {
    this.setState({ value });
    this.props.onChange({
      target: {
        name: this.props.name,
        value: value.value,
      },
    });
  };

  renderEmptyMessage = () => (
    <div className={classes.emptyMessage}>
      <span className={classes.emptyMessageBody}>
        Sie können
        <Link to="/numberrange" className={classes.emptyMessageLink}>
          Nummernkreise
        </Link>
        anlegen, um diese besser ablegen zu können.
      </span>
    </div>
  );

  render() {
    const props = this.props;
    const placeholder = <span>Nummernkreis wählen</span>;
    const allData = props.numberRanges;
    const selectData = [];

    _.forOwn(allData, data => {
      // create new object that will be handled by griddle
      if (data.active) {
        const preview = renderPreview(data.format, false, null, false, true);
        selectData.push({
          value: data.id,
          title: data.name,
          label: `${data.name} (${preview.join('')})`,
        });
      }
    });

    if (
      typeof this.props.showEmptyMessage !== 'undefined' &&
      !selectData.length
    ) {
      return this.renderEmptyMessage();
    }

    return (
      <div className="section">
        <Select
          onChange={this.setValue}
          options={selectData}
          placeholder={placeholder}
          value={this.state.value}
        />
      </div>
    );
  }
}
NumberRangePicker.propTypes = {
  name: PropTypes.string,
  showEmptyMessage: PropTypes.bool,
  default: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.array,
  ]),
  onChange: PropTypes.func,
};
export default connect(mapStateToProps, mapActionCreators)(NumberRangePicker);



// WEBPACK FOOTER //
// ./src/components/NumberRangePicker/NumberRangePicker.js